import Vue from 'vue';
import DesignSystem from './DesignSystem'

new Vue({
    ... DesignSystem
}).$mount('#root');